import React, { useContext, useRef, useState, useMemo, useEffect } from 'react'
import ModalWindow from 'components/ModalWindow'
import { Button, Icon, Dropdown, Loader, Popup } from 'semantic-ui-react'
import { injectIntl } from 'react-intl'
import { UserContext, NotifyContext } from 'context'

import api from 'actions/api'

import doRequest from 'actions/doRequest'

function ApplicationCancelModal(props) {
    const { application = null, applicationsIdList = [], closeParentModal = null, intl, reloadApp, withoutLabel = false } = props
    const { logout } = useContext(UserContext)

    const [open, setOpen] = useState(false)
    const [loading, setLoading] = useState(false)
    const [sending, setSending] = useState(false)
    const [disabled, setDisabled] = useState(false)
    const [options, setOptions] = useState({ reasons: [] })
    const [reason, setReason] = useState('')
    const abortRequestRef = useRef(null)

    const { pushNotify } = useContext(NotifyContext)

    const translates = useMemo(() => ({
        noResult: intl.formatMessage({ id: "title.resultNotFound" }),
        cancelApplication: intl.formatMessage({ id: 'btn.cancelApplication' }),
        cancelApplications: intl.formatMessage({ id: 'btn.cancelApplications' }),
        cancelingReasons: intl.formatMessage({ id: 'title.cancelingReasons' }),
        applicationsCancelingReasons: intl.formatMessage({ id: 'title.applicationsCancelingReasons' })
    }), [intl.locale]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        sending ? setDisabled(true) : setDisabled(false)
    }, [sending])

    const getOptions = () => {
        setLoading(true)
        let requests = []

        requests.push(doRequest(api.rejectionReasons.list(), pushNotify, logout).ready)

        Promise.all(requests).then(result => {
            const res = result.reduce((acc, data) => {
                if (data.reasons) return { ...acc, reasons: data.reasons.map((reason) => { return { key: reason.id, value: reason.id, text: intl.formatMessage({ id: `rejectionReason.${reason.translateIndex}` }) } }) };
                return acc;
            }, {})

            setOptions({ ...res })
        }).catch(console.error)
            .finally(() => setLoading(false))
    }

    useEffect(getOptions, []) // eslint-disable-line react-hooks/exhaustive-deps

    const getButtons = () => [
        { title: applicationsIdList.length > 1 ? translates.cancelApplications : translates.cancelApplication, onClick: cancelApplication, disabled: disabled, loading: sending },
    ]

    const openModal = () => {
        setOpen(true)
    }

    const closeModal = () => {
        setOpen(false)
        applicationsIdList.length === 0 && closeParentModal()
    }

    const cancelApplication = () => {
        if (typeof reason !== 'number') {
            pushNotify('error', 'title.error', 'msg.cancelReasonMustBeChoosen', 2000)
            return
        }

        setSending(true)

        const req = applicationsIdList.length > 0 ?
            doRequest(api.applications.updateApplicationsList({ applicationsIdList, statusId: 4, rejectionReason: reason }), pushNotify, logout)
            :
            doRequest(api.applications.editApplication({ id: application.id, statusId: 4, rejectionReason: reason }), pushNotify, logout)
        abortRequestRef.current = req.abort

        req.ready.then(data => {
            if (data) {
                pushNotify('success', 'title.success', 'msg.sendRequstSuccess', 2000)
            }
            closeModal()
            reloadApp();
        }).catch(error => {
            setReason('')
            setSending(false)
        })

    }

    return (
        <ModalWindow
            closeIcon
            size="tiny"
            iconType="info"
            title={applicationsIdList.length > 1 ? translates.applicationsCancelingReasons : translates.cancelingReasons}
            open={open}
            onClose={() => setOpen(false)}
            onOpen={() => openModal()}
            trigger={
                withoutLabel ?
                    <Button className="actionButton" icon> <Popup inverted content={applicationsIdList.length > 1 ? translates.cancelApplications : translates.cancelApplication} trigger={<Icon name="undo" />} /></Button>
                    :
                    <Button className="actionButton" icon><Icon name="undo" /><span>{applicationsIdList.length > 1 ? translates.cancelApplications : translates.cancelApplication}</span></Button>
            }
            actions={getButtons()}
        >
            {loading ?
                <Loader className={"page-loader"} active inline="centered" />
                :
                <div className="applicationCancel">
                    <div className="reasonItem">
                        <Dropdown
                            fluid
                            placeholder={applicationsIdList.length > 1 ? `${translates.applicationsCancelingReasons}:` : `${translates.cancelingReasons}:`}
                            options={options.reasons}
                            selection
                            disabled={sending}
                            value={reason}
                            noResultsMessage={translates.noResult}
                            onChange={(e, { value }) => setReason(value)}
                        />
                    </div>
                </div>}
        </ModalWindow>
    )
}

export default injectIntl(ApplicationCancelModal)